import {memo} from 'react'
import {RelativeTime, Timeline} from '@primer/react'
import type {TimelineItem} from '../../../page-data/payloads/timeline'
import {TimelineItemBadge} from './TimelineItemBadge'
import {TimelineItemAction} from './TimelineItemAction'

const timestampTooltipFormatter = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  timeZoneName: 'short',
})

export const TimelineEvent = memo(function TimelineEvent({item}: {item: TimelineItem}) {
  const login = item.user?.displayLogin
  const timestamp = item.timestamp ? new Date(item.timestamp) : null

  return (
    <Timeline.Item condensed>
      <TimelineItemBadge item={item} />
      <Timeline.Body>
        {login && <strong>{login}</strong>} <TimelineItemAction item={item} />
        {timestamp && (
          <>
            {' '}
            <RelativeTime
              className="color-fg-muted"
              date={timestamp}
              noTitle
              title={timestampTooltipFormatter.format(timestamp)}
            />
          </>
        )}
      </Timeline.Body>
    </Timeline.Item>
  )
})
